import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import VeiculoService from 'services/VeiculoService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
	pagination: {
		content: [],
		totalElements: 0,
		totalPages: 0,
		currentPage: 0,
		pageSize: 10,
	},
	acumuladores: null,
	loadingAcumuladores: false,
	erroAcumuladores: null,
}

export const getAllPaginated = createAsyncThunk('veiculo/allPaginated', async (params, { rejectWithValue }) => {
	try {
		const response = await VeiculoService.paginated(params)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar veículos')
	}
})

export const getAll = createAsyncThunk('veiculo/all',async () => {
    const response = await VeiculoService.all()
    return response;
})

export const disponiveis = createAsyncThunk('veiculo/disponiveis',async () => {
    const response = await VeiculoService.disponiveis()
    return response;
})

export const id = createAsyncThunk('veiculo/id',async (data, { rejectWithValue }) => {
	try {
		const response = await VeiculoService.id(data)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar veículo')
	}
})

export const save = createAsyncThunk('veiculo/save',async (data, { rejectWithValue }) => {
	try {
		const response = await VeiculoService.save(data)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao salvar veículo')
	}
})

export const obterAcumuladoresVeiculo = createAsyncThunk(
  'veiculo/obterAcumuladores',
  async (id, { rejectWithValue }) => {
    try {
      const response = await VeiculoService.obterAcumuladores(id)
      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erro ao obter acumuladores')
    }
  }
)

export const ajustarAcumuladoresVeiculo = createAsyncThunk(
  'veiculo/ajustarAcumuladores',
  async ({ id, km, horas }, { rejectWithValue }) => {
    try {
      const response = await VeiculoService.ajustarAcumuladores(id, { km, horas })
      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erro ao ajustar acumuladores')
    }
  }
)

export const veiculoSlice = createSlice({
	name: 'veiculo',
	initialState,
	reducers: {
		clearVeiculoEdicao: (state) => {
			state.edicao = null;
		  },
		resetarAcumuladores: (state) => {
		  state.acumuladores = null
		  state.loadingAcumuladores = false
		  state.erroAcumuladores = null
		},
	},
    extraReducers: (builder) => {
		builder
			.addCase(getAllPaginated.pending, (state) => {
				state.loading = true
			})
			.addCase(getAllPaginated.fulfilled, (state, action) => {
				state.loading = false
				state.pagination = {
					content: action.payload.content,
					totalElements: action.payload.totalElements,
					totalPages: action.payload.totalPages,
					currentPage: action.payload.number,
					pageSize: action.payload.size,
				}
			})
			.addCase(getAllPaginated.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(getAll.pending, (state) => {
				state.loading = true
			})
			.addCase(getAll.fulfilled, (state, action) => {
				state.loading = false
				// state.redirect = '/'
				state.veiculos = action.payload
			})
			.addCase(getAll.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			}).addCase(disponiveis.pending, (state) => {
				state.loading = true
			})
			.addCase(disponiveis.fulfilled, (state, action) => {
				state.loading = false
				// state.redirect = '/'
				state.veiculosDisponiveis = action.payload
			})
			.addCase(disponiveis.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			}).addCase(id.pending, (state) => {
				state.loading = true
			})
			.addCase(id.fulfilled, (state, action) => {
				state.loading = false
				// state.redirect = '/app/cliente/default'
				state.edicao = action.payload
			})
			.addCase(id.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(save.pending, (state) => {
				state.loading = true
			})
			.addCase(save.fulfilled, (state, action) => {
				state.loading = false
				// state.redirect = '/app/cliente/default'
				// state.users = action.payload
				state.edicao = null
			})
			.addCase(save.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(obterAcumuladoresVeiculo.pending, (state) => {
				state.loadingAcumuladores = true
				state.erroAcumuladores = null
			})
			.addCase(obterAcumuladoresVeiculo.fulfilled, (state, action) => {
				state.loadingAcumuladores = false
				state.acumuladores = action.payload
			})
			.addCase(obterAcumuladoresVeiculo.rejected, (state, action) => {
				state.loadingAcumuladores = false
				state.erroAcumuladores = action.payload
			})
			.addCase(ajustarAcumuladoresVeiculo.pending, (state) => {
				state.loadingAcumuladores = true
				state.erroAcumuladores = null
			})
			.addCase(ajustarAcumuladoresVeiculo.fulfilled, (state) => {
				state.loadingAcumuladores = false
			})
			.addCase(ajustarAcumuladoresVeiculo.rejected, (state, action) => {
				state.loadingAcumuladores = false
				state.erroAcumuladores = action.payload
			})
	},
})

export const {
	showLoading,
	clearVeiculoEdicao,
	resetarAcumuladores
} = veiculoSlice.actions

export default veiculoSlice.reducer